import React, { useEffect, useState } from "react";
import styles from "./PageRestrict.module.css";
import warningIcon from "./Featured icon.svg";
import ReactDOM from "react-dom";
import MailToSuperAdmin from "app/common/mail-to/MailToSuperAdmin";

function PageRestrict({ blockPageStyle = null, action = null, moduleBlock=false }) {
  const isVerified = window.localStorage.getItem("IsAccountVerified");

  const [sideBarCollapsed, setSideBarCollapsed] = useState(
    localStorage.getItem("sideNavCollapsed") === "true",
  );

  useEffect(() => {
    const handler = (e) => {
      setSideBarCollapsed(e.detail.collapsed);
    };
    window.addEventListener("side-nav-toggle", handler);
    return () => {
      window.removeEventListener("side-nav-toggle", handler);
    };
  }, []);

  const updatedStyle = {
    ...blockPageStyle,
    ...(isVerified === "false" && {
      top: "100px",
      height: "calc(100vh - 110px)",
    }),
    zIndex: 9,
  };

  return (
    <div
      className={sideBarCollapsed || moduleBlock ? styles.overlayCollapsed : styles.overlay}
      style={updatedStyle}
    >
      <div className={styles.modal}>
        <div className={styles.header}>
          <img src={warningIcon} alt="Warning" className={styles.icon} />
          <h2 className={styles.title}>Access Restricted</h2>
        </div>
        <div className={styles.description}>
          <div>You don’t have access to this feature.</div>
          <div>
            Contact your Super Admin <MailToSuperAdmin request={action} /> for
            permission.
          </div>
        </div>
      </div>
    </div>
  );
}

let restrictRoot = null;
let currentPath = null;
let navigationPatched = false;

function patchNavigationOnce() {
  if (navigationPatched) return;
  navigationPatched = true;

  const notifyRouteChange = () => {
    if (restrictRoot && window.location.pathname !== currentPath) {
      hidePageRestrict();
    }
  };

  window.addEventListener("popstate", notifyRouteChange);

  const originalPushState = window.history.pushState;
  window.history.pushState = function (...args) {
    const result = originalPushState.apply(this, args);
    notifyRouteChange();
    return result;
  };

  const originalReplaceState = window.history.replaceState;
  window.history.replaceState = function (...args) {
    const result = originalReplaceState.apply(this, args);
    notifyRouteChange();
    return result;
  };
}

export function showPageRestrict(blockPageStyle = null, action = null, moduleBlock) {
  patchNavigationOnce();
  currentPath = window.location.pathname;

  if (!restrictRoot) {
    restrictRoot = document.createElement("div");
    document.body.appendChild(restrictRoot);
  }
  ReactDOM.render(
    <PageRestrict blockPageStyle={blockPageStyle} action={action} moduleBlock={moduleBlock}/>,
    restrictRoot,
  );
}

export function hidePageRestrict() {
  if (restrictRoot) {
    ReactDOM.unmountComponentAtNode(restrictRoot);
    document.body.removeChild(restrictRoot);
    restrictRoot = null;
    currentPath = null;
  }
}

export default PageRestrict;
